<template>
  <div v-if="!isOnline">
    <div class="fullscreen gray-out"></div>
    <toast-message :toast="{style: 'fit-style', message: 'Waiting for internet connection...'}">
    </toast-message>
  </div>
  <div id="wrapper">
    <div id="game-wrapper" v-if="view === 'game'">
      <top-bar :game-status="gameStatus"> </top-bar>
      <div class="flexbox main-content">
        <dead-hall team-name="red" :losts="redDeadHall"> </dead-hall>
        <game-board :tile-map="tileMap"> </game-board>
        <dead-hall team-name="blue" :losts="blueDeadHall"> </dead-hall>
      </div>
      <div v-if="game.gameStage === 'prepStage'" class="flexbox">
        <unit-selector :units="game.currentPlacingUnits"> </unit-selector>
        <button type="button" class="btn btn-primary btn-sm margin-r margin-l" @click="game.toggleHoverUnits()">
          Hover Units: {{ game.allowHoverUnits ? 'On' : 'Off' }} (Space) 
        </button>
        <button type="button" class="btn btn-primary btn-sm margin-r" @click="game.toggleAutoJump()">
          Auto Jump: {{ game.allowAutoJump ? 'On' : 'Off' }} (X) 
        </button>
        <button type="button" class="btn btn-primary btn-sm margin-r" @click="game.reset()"> Reset Loadout (R) </button>
        <button type="button" class="btn btn-primary btn-sm margin-r" @click="validateUnitLoadout()"> Validate Loadout (V)</button>
        <button type="button" class="btn btn-primary btn-sm margin-r" @click="game.setReadyStatus()">
          {{ game.selfReady ? "Cancel" : "Set" }} Ready (T) 
        </button>
        <button type="button" class="btn btn-outline-danger btn-sm margin-r"> Abandon Match (K)</button>
        <toast-message v-if="showToast" :toast="toastObject"> </toast-message>
      </div>
      <div v-else>
        <!-- <button :onclick="reconnect"> Reconnect </button> -->
        <unload-selector v-if="showUnloadSelector" :unload-units="unloadUnits"> </unload-selector>
      </div>
    </div>
    <div v-else-if="view === 'error'">
      <gameroom-error :error-code="errorCode"> </gameroom-error>
    </div>
    <div v-else>
      <p> Loading... </p>
    </div>
  </div>
</template>

<script>
import GameBoard from './Game/GameBoard.vue'
import DeadHall from './Game/DeadHall.vue';
import UnitSelector from './Game/UnitSelector.vue';
import {board, areas, gameStages} from '../scripts/GameVariables';
import Game from '../scripts/Game';
import UnloadSelector from './Game/UnloadSelector.vue';
import TopBar from './Game/TopBar.vue';
import ToastMessage from './Game/ToastMessage.vue';
import GameroomError from './GameroomError.vue';

export default {
  components: {
    GameBoard, DeadHall, GameroomError,
    UnitSelector,
    UnloadSelector, TopBar, ToastMessage
  },
  data() {
    let game = new Game();
    return{
      gameStatus: {
        gameStage: gameStages.prepStage,
        turnPlayer: 'red',
        turnNumber: 0
      },
      view: 'loading',
      errorCode: 0,
      game: game,
      tileMap: game.tileMap,
      groundTypes: areas,
      allowHoverUnits: true,
      board: board,
      tileMapUpdater: false,
      redDeadHall: [],
      blueDeadHall: [],
      selectMode: false,
      unloadUnits: [],
      gameObjective: {objective: ''},
      showToast: false,
      toastTimerId: -1,
      isOnline: true,
      toastObject: {
        message: '',
        style: 'red-style',
      },
    };
  },
  inject: ['socket', 'setAuthToken', 'initSocket', 'session'],
  provide() {
    return {
      game: this.game,
      tileMap: this.tileMap,
      groundTypes: this.groundTypes,
      onTileClick: this.game.onTileClick,
      setPlacingUnit: this.setPlacingUnit,
      tileMapUpdater: this.tileMapUpdater,
      selectMode: () => this.selectMode,
      gameObjective: this.gameObjective,
    };
  },
  computed: {
    showUnloadSelector(){
      if(this.selectMode){
        const unit = this.game.getUnitByLocation(...this.game.selectedUnitCords);
        return (unit.isVehicle || (unit.type === 'troop' && unit.isCarryingFlag));
      }
      return false;
    },
  },
  methods: {
    reconnect() {
      const that = this;
      this.socket.disconnect();
      setTimeout(() => {
        that.socket.connect();
      }, 1000);
    },
    validateUnitLoadout(){
      this.game.validateLoadout(true);
    },
    updateLoadoutValidator(response){
      console.log(response);
      const that = this;
      this.toastObject.style = response.accepted ? 'fit-style' : 'red-style'; 
      this.toastObject.message = response.message;
      this.showToast = true;
      clearTimeout(this.toastTimerId);
      this.toastTimerId = setTimeout(() => {
        that.showToast = false;
      }, 3000);
    },
    updateObjective(objective){
      this.gameObjective.objective = objective;
    },
    onKeyDown(event){
      this.game.onKeyPress(event);
    },
    updateTileMap(tileMap){
      this.tileMap = [...tileMap];
    },
    updateDeadHall(team, hall){
      if(team === 'red'){
        this.redDeadHall = [...hall];
      }
      else if(team === 'blue'){
        this.blueDeadHall = [...hall];
      }
    },
    updateSelectMode(value) {
      this.selectMode = value;
    },
    updateUnloadUnits(unloadUnits) {
      this.unloadUnits = [...unloadUnits];
    },
    updateGameStatus(gameStatus) {
      this.gameStatus = {...gameStatus};
    },
    setInitialData(initialData) {
      this.game.setGameSettings(initialData.matchSettings);
      if(initialData.authToken){
        this.setAuthToken(initialData.authToken);
      }
      this.game.init(this.socket, this.$route.params.gameId);
      this.view = 'game';
    },
  },
  created() {
    /* Setting game updaters */
    this.game.updaters.objective = this.updateObjective;
    this.game.updaters.tileMap = this.updateTileMap;
    this.game.updaters.deadHall = this.updateDeadHall;
    this.game.updaters.selectMode = this.updateSelectMode;
    this.game.updaters.unloadUnits = this.updateUnloadUnits;
    this.game.updaters.gameStatus = this.updateGameStatus;
    this.game.updaters.loadoutValidator = this.updateLoadoutValidator;
  },
  mounted() {
    /* Connecting to server */
    if(!this.socket){
      this.socket = this.initSocket({
        actionType: 'game.join',
        gameId: this.$route.params.gameId,
        authToken: this.session.authToken
      });
      this.socket.connect();
      this.socket.on('connect_error', (err) => {
        if(err.message.includes('||')){
          const [message, ...debug] = err.message.split('||');
          err.message = message;
          for(let prompt of debug){
            console.log(prompt);
          }
        }
        if (parseInt(err.message) > 0){
          this.view = 'error';
          this.errorCode = parseInt(err.message);
        }
        else{
          this.isOnline = false;
        }
      });
      this.socket.on('connect', () => {
        this.isOnline = true;
        console.log('Connected to socket!');
      });
      this.socket.on('disconnect', () => {
        this.socket.auth.authToken = this.session.authToken;
        this.socket.auth.actionType = 'game.join';
        console.log('Disconnect from socket!');
      });
      this.socket.once('match.initialData', this.setInitialData);
    }
    else{
      this.setInitialData(this.session.initialData);
    }
    this.socket.on('match.playerConnected', () => {
      console.log('Player connected!')
    });
    /* Catching key pressed */
    const that = this;
    window.addEventListener("keydown", (e) => {that.onKeyDown(e)});
  },
};
</script>

<style scoped>
#game-wrapper{
  width: 80%;
  margin-left: auto;
  margin-right: auto;
}
.main-content{
  margin-bottom: 8px;
}
.margin-r{
  margin-right: 5px;
}
.margin-l{
  margin-left: 5px;
}
.gray-out{
  z-index: 100 !important;
  background: rgba(0, 0, 0, 0.5);
}
</style>
